import { useEffect } from 'react';
import styled from 'styled-components';
import { Box } from '@awaze/design-system.components.box';
import { breakpoints, getShadowStyle, pxToRems } from '@awaze/design-system.utils.react';
import { InputFacade, InputFacadeWrappedStyled, } from '@awaze/design-system.components.input-facade';
import { PopoverContainerStyled } from '@awaze/design-system.components.popover';
const [desktopMinWidth] = breakpoints;
const mobileMaxWidth = desktopMinWidth - 1;
export const SearchFormContainer = styled.div `
  position: relative;
  z-index: 1;
`;
export const onDesktop = `@media screen and (min-width: ${desktopMinWidth}px)`;
export const onMobile = `@media screen and (max-width: ${mobileMaxWidth}px)`;
export const SearchFormStyle = styled.div `
  display: flex;
  flex-direction: column;
  border-radius: 4px;

  ${onDesktop} {
    background-color: ${({ theme }) => theme.ColorWhiteOpacity100};
    flex-direction: row;
    box-shadow: ${({ theme }) => getShadowStyle({ theme, depth: 3 })};

    > div + div {
      border-left: 1px solid ${({ theme }) => theme.ColorGrey100};
    }

    > * {
      flex: 1;
    }

    > :last-child {
      flex: 0;
      flex-basis: 10%;
    }
  }

  .searchBtn {
    margin-top: ${pxToRems(8)};

    ${onDesktop} {
      margin: ${(showDestinationField) => showDestinationField
    ? `${pxToRems(12)} ${pxToRems(12)} ${pxToRems(12)} ${pxToRems(8)}`
    : `${pxToRems(12)} ${pxToRems(12)} ${pxToRems(12)} auto`};
      line-height: ${pxToRems(16)};
      width: auto;
    }
  }
`;
export const StyledContainerStyled = styled.div `
  display: inline-flex;
  width: 100%;

  > span,
  ${InputFacadeWrappedStyled}, ${PopoverContainerStyled} {
    flex: 1;
    width: 100%;
    height: 100%;
  }

  .popoverStyled {
    max-width: ${pxToRems(desktopMinWidth)};
    min-width: 320px;
    height: auto;
  }

  ${onMobile} {
    display: none;
  }
`;
export const InputFacadeStyled = styled(InputFacade) `
  &:active,
  &:focus {
    outline: 2px solid
      ${({ theme }) => theme.ColorComponentSearchBarBorderActive};
  }
`;
export const MobileFormat = styled.div `
  ${onDesktop} {
    display: none;
  }
`;
export const MobileBox = styled(Box) `
  ${onDesktop} {
    display: none;
  }
`;
export const DesktopFormat = styled.div `
  ${onMobile} {
    display: none;
  }
`;
export const useHandleFormatChange = (onChange) => useEffect(() => {
    const closeHandler = onChange;
    const matched = window.matchMedia(`(max-width: ${mobileMaxWidth}px)`);
    matched.addEventListener('change', closeHandler);
    return () => matched.removeEventListener('change', closeHandler);
}, [onChange]);
//# sourceMappingURL=search-form-composition.styles.js.map